export const clients = [
  {
    name: "Erin Donovan",
    role: "COO - College Mastermind",
    platform: "LinkedIn",
    image: "https://paperbell.blob.core.windows.net/coachcompare/7jx6laj6mvcj21p4rp8v39ukkyef",
    stars: 5,
    disc: `From designing an intuitive UI to implementing scalable backend APIs, Faizan demonstrated excellent full-stack development skills.`
  },
  {
    name: "Muhammad Umair",
    role: "Business Owner",
    platform: "LinkedIn",
    image: "https://media.licdn.com/dms/image/v2/D4D03AQFApqm5XacZMw/profile-displayphoto-shrink_400_400/B4DZPOVrqrGUAs-/0/1734333612697?e=1774483200&v=beta&t=PuzBM68wly8qMmWYjz-W_3Jzq8AYZURCoHPTwv1k0Do",
    stars: 5,
    disc: `It's an absolute pleasure to recommend Faizan as a highly skilled full-stack developer specializing in the MERN stack.`
  },
  {
    name: "Muhammad Waqas",
    role: "Private Client",
    platform: "Facebook",
    image: "/images/clients/client4.jpg",
    stars: 5,
    disc: `Faizan's attention to detail and problem-solving skills were outstanding. We look forward to working together again.`
  },
  {
    name: "Intisar Al Hinai",
    role: "Team Lead - College Mastermind",
    platform: "LinkedIn",
    image: "/images/clients/client4.jpg",
    stars: 5,
    disc: `Our project's success is largely thanks to Faizan’s technical expertise and strong communication throughout the development process.`
  }
]

export const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  initialSlide: 0,
  arrows: false,
  responsive: [
    {
      breakpoint: 990,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        initialSlide: 2
      }
    },
    {
      breakpoint: 530,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
}